import React from "react";
import "../style/MyCar.css";
import { useNavigate } from "react-router-dom";

function CarSelect({ carro }) {
  const navigate = useNavigate();
  const backgroundurl = carro.imagenes[0];

  const handleSelect = () => {
    navigate(`/createauction/${carro._id}`);
  };

  return (
    <div className="main-container-car car-select">
      <div className="car-models-m">
        <div className="movil-marca">
          <p className="car-title-m">
            {carro.marca} {carro.modelo} {carro.anio}
          </p>
        </div>
        <img src={backgroundurl} alt="" className="car-img" />
      </div>
      <div className="info-car">
        <div className="info-info">
          <div className="head">
            <p className="car-title">
              {carro.marca} {carro.modelo} {carro.anio}
            </p>
          </div>
          <p className="car-lote">Lote: {carro.lote}</p>
          <div className="especificaciones">
            <p className="millaje">Millaje: {carro.millaje}</p>
            <p className="motor">Motor: {carro.motor}</p>
            <p className="combustible">Combustible: {carro.combustible}</p>
          </div>
          <div className="precios">
            <p className="precio">Precio: L. {carro.precio}</p>
          </div>
        </div>
        <div className="edit-btns">
          <button className="create-auction-btn" onClick={handleSelect}>
            Crear subasta
          </button>
        </div>
      </div>
    </div>
  );
}

export default CarSelect;
